import { render, staticRenderFns } from "./DeviceShowComp.vue?vue&type=template&id=9b851a36&scoped=true&"
import script from "./DeviceShowComp.vue?vue&type=script&lang=js&"
export * from "./DeviceShowComp.vue?vue&type=script&lang=js&"
import style0 from "./DeviceShowComp.vue?vue&type=style&index=0&id=9b851a36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b851a36",
  null
  
)

export default component.exports